export default "__VITE_ASSET__gSRLuxo7__"